import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      language: localStorage.getItem('language') || 'zh-CN',
  },
  getters: {
  },
  mutations: {
      changeLanguage(state, language) {
          state.language = language
          localStorage.setItem('language', language)
      }
  },
  actions: {
      changeLanguage(context, language) {
          context.commit('changeLanguage', language)
      }
  },
  modules: {
  }
})
